// The background plugin
import background from "@react-page/plugins-background";
// import css as well. currently, we caannot do this here in the demo project and have moved that to _app.tsx
// see https://github.com/vercel/next.js/issues/19717
import "@react-page/plugins-background/lib/index.css";

// The divider plugin
import divider from "@react-page/plugins-divider";

// The html5-video plugin
import html5video from "@react-page/plugins-html5-video";
import "@react-page/plugins-html5-video/lib/index.css";

// The image plugin
import { imagePlugin } from "@react-page/plugins-image";
import "@react-page/plugins-image/lib/index.css";
// The spacer plugin
import spacer from "@react-page/plugins-spacer";
// import '@react-page/plugins-spacer/lib/index.css';
// The video plugin
//import video from "@react-page/plugins-video";
// import '@react-page/plugins-video/lib/index.css';
// The rich text area plugin
import { defaultSlate } from "./slate";

//Plugins
import ButtonWithLink from "./ButtonWithLink";
import Accordion from "./Accordion";
import iconWithLink from "./iconwithLink";
import iconWithText from "./iconwithText";
import Table from "./Table";
import productLayoutPlugin from "./productLayoutPlugin";
import serviceLayoutPlugin from "./serviceLayoutPlugin";
import dynamicTablePlugin from "./dynamicTableLayout";
import dividerText from "./DividerText";
import logoWithTitle from "./logoWithTitle";
import aboutLayoutPlugin from "./aboutLayoutPlugin";
import TableWithColumn from "./TableWithColumn";
import TableWithTwoColumn from "./TableWithTwoColumn";
import TableWithEightColumn from "./TableWithEightColumn";

const imageUploadService = (defaultUrl) => (file, reportProgress) => {
  const dataFile = { rawFile: file };
  return new Promise((resolve, reject) => {
    convertFileToBase64(dataFile).then((base64File) =>
      resolve({ url: base64File })
    );
  });
};

// Define which plugins we want to use.
const cellPlugins = [
  defaultSlate,
  spacer,
  imagePlugin({ imageUpload: imageUploadService("/images/react.png") }),
  background(),
  divider,
  iconWithText,
  Accordion,
  iconWithLink,
  ButtonWithLink,
  Table,
  serviceLayoutPlugin,
  productLayoutPlugin,
  aboutLayoutPlugin,
  dynamicTablePlugin,
  dividerText,
  logoWithTitle,
  TableWithColumn,
  TableWithTwoColumn,
  TableWithEightColumn,
];

export default cellPlugins;
